module.exports = __webpack_public_path__ + "static/media/1016904.22299a60.jpg";